module.exports = __webpack_public_path__ + "img/delete.e5a67b7c.svg";